export default "__VITE_ASSET__b160ccbb__"